// simply returns the window.settings object

const settings = window.settings;

export default settings;
